import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const EyeIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 12"
  >
    <path
      fillRule="evenodd"
      d="M1.874 6q.101.163.249.38c.312.457.767 1.064 1.345 1.669C4.643 9.28 6.208 10.383 8 10.383s3.357-1.102 4.533-2.334A13.3 13.3 0 0 0 14.126 6a13.312 13.312 0 0 0-1.594-2.049C11.358 2.72 9.793 1.617 8 1.617S4.643 2.719 3.468 3.95A13.3 13.3 0 0 0 1.874 6M15 6l.658-.36-.001-.002-.002-.004-.008-.014-.029-.05-.104-.178a14.79 14.79 0 0 0-1.896-2.476C12.343 1.58 10.407.116 8 .116s-4.343 1.465-5.618 2.8a14.8 14.8 0 0 0-2 2.654l-.029.05-.008.014-.002.004v.002L1 6l-.658-.36a.75.75 0 0 0 0 .72L1 6c-.658.36-.659.359-.658.36l.001.002.002.004.008.015a5 5 0 0 0 .134.227 14.804 14.804 0 0 0 1.896 2.476c1.274 1.335 3.209 2.8 5.617 2.8s4.343-1.465 5.618-2.8a14.8 14.8 0 0 0 2-2.654l.029-.05.008-.014.002-.004V6.36zm0 0 .658.36a.75.75 0 0 0 0-.72zM8 4.417a1.583 1.583 0 1 0 0 3.166 1.583 1.583 0 0 0 0-3.166M4.917 6a3.083 3.083 0 1 1 6.166 0 3.083 3.083 0 0 1-6.166 0"
      clipRule="evenodd"
    />
  </svg>
);
EyeIcon.id = 'EyeIcon';
EyeIcon.displayName = 'EyeIcon';
export default EyeIcon;
